import styles from './spinner-full-page.module.scss';
import Spinner from 'wa-storybook/components/general/spinner/spinner';

const SpinnerFullPage = () => {
  return (
    <div className={styles.wrapper}>
      <Spinner top='calc(50% - 240px)' />
    </div>
  );
};

SpinnerFullPage.displayName = 'SpinnerFullPage';
export default SpinnerFullPage;
